export default __webpack_public_path__ + "static/media/who-we-are-Header-4k.1ede576f.jpg";